import React from "react";
import {
  Grid,
  Button,
  Card,
  CardActionArea,
  CardActions,
  CardContent,
  CardMedia,
} from "@material-ui/core";
import { useHistory } from "react-router-dom";
// styles
import useStyles from "./styles";
// import React from "react"
import { UserAuth } from "../../context/AuthContext";
// Create a reference to the cities collection
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../../context/firebase";

// components
import { Typography } from "../../components/Wrappers/Wrappers";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function StudentDashboard(props) {
  var classes = useStyles();
  // const {hasPermission, define } = useAccess()
  const { user } = UserAuth();
  const navigate = useHistory();
  const permissions = {
    "ABPHYSICS FOCUS:class11": true,
    "ABPHYSICS FOCUS:class12": true,
    "Repeater JEE/NEET:class11":true,
    "Repeater JEE/NEET:class12":false,

  };
  // var parsedData = JSON.parse(permissions);
  const showToast = () => {
    toast.error("❌You are not allowed here!!", {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };
  const handlepdf11 = () => {
    try {
      navigate.push("/student/pdf11");
    } catch (err) {
      alert(err.message);
    }
  };

  const handlepdf12 = () => {
    try {
      navigate.push("/student/pdf12");
    } catch (err) {
      alert(err.message);
    }
  };
  const Access = async (className) => {
    var currentuid = user.uid;
    // console.log(currentuid);
    // Create a query against the collection.
    const q = query(collection(db, "users"), where("uid", "==", currentuid));

    const querySnapshot = await getDocs(q);
    var batch;

    querySnapshot.forEach((doc) => {
      batch = doc.data().batch;
    });

    // console.log(permissions);
    const status = `${batch}:${className}`;
    if (permissions[status] && className === "class11") handlepdf11();
    else if (permissions[status] && className === "class12") handlepdf12();
    else showToast();
  };
  return (
    <>
      <Grid container spacing={9}>
        <Grid item xs={12} md={6} lg={6} sm={12} spacing={4}>
          <Card className={classes.card} onClick={handlepdf11}>
            <CardActionArea>
              <CardMedia
                className={classes.media}
                image="https://images.unsplash.com/photo-1636466497217-26a8cbeaf0aa?crop=entropy&cs=tinysrgb&fm=jpg&ixlib=rb-1.2.1&q=80&raw_url=true&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1074"
                title="Class 11"
              />
              <CardContent>
                <Typography gutterB ottom variant="h5" component="h2">
                  Class 11
                </Typography>
                {/* <Typography variant="body2" color="textSecondary" component="p">
                  Lizards are a widespread group of squamate reptiles, with over
                  6,000 species, ranging across all continents except Antarctica
                </Typography> */}
              </CardContent>
            </CardActionArea>
            <CardActions>
              <Button
                size="medium"
                color="primary"
                onClick={handlepdf11}
              >
                Learn More
              </Button>
            </CardActions>
          </Card>
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          lg={6}
          sm={12}
          spacing={4}
          onClick={handlepdf12}
        >
          <Card className={classes.card}>
            <CardActionArea>
              <CardMedia
                className={classes.media}
                image={`https://images.unsplash.com/photo-1612521564381-8b0d19cc4951?ixlib=rb-1.2.1&raw_url=true&q=80&fm=jpg&crop=entropy&cs=tinysrgb&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1097`}
                title="Class 12"
              />
              <CardContent>
                <Typography gutterBottom variant="h5" component="h2">
                  Class 12
                </Typography>
                {/* <Typography variant="body2" color="textSecondary" component="p">
                  Lizards are a widespread group of squamate reptiles, with over
                  6,000 species, ranging across all continents except Antarctica
                </Typography> */}
              </CardContent>
            </CardActionArea>
            <CardActions>
              <Button
                size="small"
                color="primary"
                onClick={handlepdf12}
              >
                Learn More
              </Button>
            </CardActions>
          </Card>
        </Grid>
      </Grid>
    </>
  );
}
